import React, { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { PartStateReducer } from "../reducers/PartStateReducer";

const PartStateContext = createContext({
	state: PartStateReducer.getInitialState(),
	actions: PartStateReducer.actions,
});

export const usePartStateContext = () => useContext(PartStateContext);

export const PartStateProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: PartStateReducer.getInitialState(),
		reducers: PartStateReducer.caseReducers,
	});

	return (
		<PartStateContext.Provider value={{ state, actions }}>
			{children}
		</PartStateContext.Provider>
	);
};
